<button mat-button type="button" (click)="handleClick()" [disabled]="disabled">{{ 'common.cancel' | translate }}</button>
